import './App.css';
import Header from "./Header";
import Footer from "./Footer";
import Home from "./Home";
import {Route , Switch} from "react-router-dom";
import Customer from "./Customers";
import Transfer from "./Transfer";
import Transaction from "./Transaction";
import Pagenotfound from './Pagenotfound';

function App() {
  return (
    <>
      <Header />

      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/customers" component={Customer} exact />
        <Route path="/transfer" component={Transfer} exact />
        <Route path="/transaction" component={Transaction} exact/>
        <Route path="" component={Pagenotfound} />
      </Switch>

      <Footer />

      
    </>
  );
}

export default App;
